
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import store from '../../vuex/store'
import { go } from '../../libs/router'
export default {
components: {
XButton,
Group,
Cell
},
data () {
return {
userInfo: {
userName: '',
mobile: ''
}
}
},
created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
var _this = this
_this.$ajax.post( _this.ajaxFactory.get( 'showMyInfo' ), {} ).then( function ( response ) {
var result = response.data
_this.userInfo.userName = result.userName
_this.userInfo.mobile = result.mobile
} ).catch( function ( response ) {
console.log( response )
} )
},
methods: {
onClick ( link ) {
go( link, this.$router )
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '个人信息' )
}
}



// WEBPACK FOOTER //
// ./src/components/user/detail.vue